<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../../app.config";

import Notifications2 from "@/components/notifications/notifications-list2";
import AuditLogTable from "@/components/notifications/components/AuditLogTable";

/**
 * Form elements component
 */
export default {
  page: {
    title: "Notificaciones",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Notifications2,
    AuditLogTable,
  },
  data() {
    return {
      title: "Notificaciones",
      
      items: [],
    };
  },
  computed: {},

  methods: {
  
  },

   mounted() {
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <b-tabs justified pills class="navtab-bg">
            <b-tab title="Notificaciones" active>
              <Notifications2 />
            </b-tab>
            <b-tab title="Historial de cambios">
              <AuditLogTable />
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </Layout>
</template>
